/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */
import { useEffect, useRef, useState } from 'react'
import ReactQuill from 'react-quill-new'
import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { NavbarTopAdmin, NavbarBottomAdmin } from '../admin/components'
import { useDispatch, useSelector } from 'react-redux'
import { aggiorna } from '../../redux/creaEvento'
import { useNavigate } from 'react-router-dom'
import DivBottom from '../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"
import axios from 'axios'
import EditImg from '../admin/components/editImg'

function EditEvento2() {
    const navigate = useNavigate()

    const redux = useSelector((state) => state.creaEvento.value)
    const dispatch = useDispatch()

    const [formData2, setFormData2] = useState({
        biglietto: redux.biglietto,
        descrizione: redux.descrizione,
        email: redux.email,
        fb: redux.fb,
        foto: redux.foto,
        idEvento: redux.id,
        incorporaUrl: redux.incorporaUrl,
        infoOrganizzatore: redux.infoOrganizzatore,
        noBiglietto: redux.noBiglietto,
        opzioniBiglietto: redux.opzioniBiglietto,
        opzioniEvento: redux.opzioniEvento,
        ospiti: redux.ospiti,
        ...(redux.ospiti && { ospite1: redux.ospiti.split('ç')[0] }),
        ...(redux.ospiti && { ospite2: redux.ospiti.split('ç')[1] }),
        ...(redux.ospiti && { ospite3: redux.ospiti.split('ç')[2] }),
        ...(redux.ospiti && { ospite4: redux.ospiti.split('ç')[3] }),
        ...(redux.ospiti && { ospite5: redux.ospiti.split('ç')[4] }),
        parcheggio: redux.opzioniEvento.includes('parcheggio') ? true : false,
        navetta: redux.opzioniEvento.includes('navetta') ? true : false,
        mercatini: redux.opzioniEvento.includes('mercatini') ? true : false,
        fiera: redux.opzioniEvento.includes('fiera') ? true : false,
        standGastronomici: redux.opzioniEvento.includes('standGastronomici') ? true : false,
        streetFood: redux.opzioniEvento.includes('streetFood') ? true : false,
        areaTavoli: redux.opzioniEvento.includes('areaTavoli') ? true : false,
        birraArtigianale: redux.opzioniEvento.includes('birraArtigianale') ? true : false,
        musica: redux.opzioniEvento.includes('musica') ? true : false,
        djSet: redux.opzioniEvento.includes('djSet') ? true : false,
        addobbi: redux.opzioniEvento.includes('addobbi') ? true : false,
        artisti: redux.opzioniEvento.includes('artisti') ? true : false,
        truccabimbi: redux.opzioniEvento.includes('truccabimbi') ? true : false,
        centroStorico: redux.opzioniEvento.includes('centroStorico') ? true : false,
        attrazioniBambini: redux.opzioniEvento.includes('attrazioniBambini') ? true : false,
        liscio: redux.opzioniEvento.includes('liscio') ? true : false,
        gruppo: redux.opzioniEvento.includes('gruppo') ? true : false,
        scuolaDiBallo: redux.opzioniEvento.includes('scuolaDiBallo') ? true : false,
        prezzo: redux.prezzo,
        sito: redux.sito,
        telefono: redux.telefono,
        youTube: redux.youTube,
        url: redux.url,
        video: redux.video, // video visualizzato in preview che proviene da MYSQL, se inserisco un video nuovo viene rivalorizzato e perde il video in MYSQL 
    })
    const [foto, setFoto] = useState([])//foto provenienti da MYSQL o dagli input del componente
    const [textEmpty, setTextEmpty] = useState({
        descrizione: null, sitoWeb: null, emailValidate: null, opzioniBiglietto: null, telefono: null, infoOrganizzatore: null
    })
    const [msgVideo, setMsgVideo] = useState({ videoStateMessage: null })
    const [validate, setValidate] = useState(null)

    const numOspiti = [1, 2, 3, 4, 5]// NUMERO MASSIMO DI OSPITI

    const prezzoDom = useRef(); const prezzoId = useRef(); const descrizione = useRef()
    const bannerSitoUff = useRef(); const btnInfoSitoUff = useRef()
    const sitoFacol_Obbl = useRef('opzionale')

    const videoChange = async (e) => {
        if (e.target.files[0]) {
            const ETarget = e.target.files[0]
            if (ETarget.type.startsWith('video/')) {
                if (ETarget.size > 100000000) {
                    setMsgVideo({ ...msgVideo, videoStateMessage: '*** Video troppo grande...max 100 mega ***' })
                    return
                }
                const v = document.getElementById('progress')
                v.style.width = '94%'; v.style.transition = 'width 40s'; document.getElementById('container').style.border = '1px solid black'
                document.getElementById('rotaryVideo').style.display = 'block'
                setMsgVideo({ ...msgVideo, videoStateMessage: 'Attendere...upload video in corso' })

                // ----------------- controllo durata del video in secondi ----------------
                const videoForDurata = document.createElement('video')
                videoForDurata.src = URL.createObjectURL(ETarget)
                videoForDurata.onloadedmetadata = async function () {
                    const duration = videoForDurata.duration
                    if (duration > 300) {
                        setMsgVideo({ ...msgVideo, videoStateMessage: '*** Video troppo lungo (max 5 min) ***' })
                        window.URL.revokeObjectURL(videoForDurata.src)
                        document.getElementById('rotaryVideo').style.display = 'none'

                    } else {// ------ ACCETTAZIONE VIDEO ----------------------------------------   
                        // rinomino il video con un nome random
                        let extens = ETarget.name.substring(ETarget.name.lastIndexOf('.') + 1)// ricavo l'estensione
                        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                        let result = ''
                        const charactersLength = characters.length
                        for (let i = 0; i < 15; i++) {
                            result += characters.charAt(Math.floor(Math.random() * charactersLength))
                        }
                        const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto
                        document.getElementById('upload-video').disabled = true

                        function uploadThenSuccess(videoName) {
                            setMsgVideo({ ...msgVideo, videoStateMessage: 'Video caricato con successo' })
                            setFormData2({ ...formData2, video: videoName }) //formData2.video è il nome del video che andrà in MYSQL
                            v.style.transition = 'width 0.1s'; v.style.width = '100%'; document.getElementById('container').style.border = '1px solid black'
                            document.getElementById('lblVideo').style.display = 'none' // +video
                            document.getElementById('rotaryVideo').style.display = 'none'
                            document.getElementById('upload-video').disabled = false
                        }
                        function uploadThenFailed() {
                            document.getElementById('rotaryVideo').style.display = 'none'
                            setMsgVideo({ ...msgVideo, videoStateMessage: '*** Problemi con il server...riprova ***' })
                            v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
                            document.getElementById('upload-video').disabled = false
                            document.getElementById('upload-video').value = ''
                        }
                        const fd = new FormData(); let flagCompress

                        if (ETarget.size > 25000000) {//video > 25 mega non lo mando al server Heroku perchè lo saturerebbe in sovraccarico
                            flagCompress = 'compress_off'
                        } else {//video < 25 mega può essere compresso dal server
                            flagCompress = 'compress_on'
                        }
                        fd.append('video', ETarget); fd.append('nomeVideo', zxc); fd.append('stato', 'siAwsBucket')
                        try {
                            const res = await axios.post(`/convertVideo/${flagCompress}`, fd, {
                                headers: { "Content-Type": "multipart/form-data" }
                            })
                            if (res.data === 'success') {
                                if (flagCompress === 'compress_on') uploadThenSuccess(`ZE_${result}.mp4`)
                                if (flagCompress === 'compress_off') uploadThenSuccess(zxc)
                            } else uploadThenFailed()
                        } catch (err) { console.log("Errore durante l'upload", err) }
                    }
                }
            }
            else {
                //video type non conforme
                setMsgVideo({ ...msgVideo, videoStateMessage: '*** Tipo video non conforme ***' })
                e.target.value = ""; return
            }
        }
    }
    function handleInputChange(e) {
        setTextEmpty({ ...textEmpty, descrizione: null, telefono: null })
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        setFormData2({ ...formData2, [name]: inputValue })//valorizzo il name del nuovo oggetto formData 
        if (/^[0-9\s-]+$/.test(inputValue) === false && inputValue) {
            switch (name) {
                case 'telefono': { setTextEmpty({ telefono: '*** Carattere o simbolo non conforme ***' }); return }
                default:
            }
        }
        setValidate(null); setTextEmpty({ sitoWeb: null })
        switch (name) {
            case 'biglietto': {
                setFormData2({ ...formData2, biglietto: true, noBiglietto: false, sito: false })
                sitoFacol_Obbl.current = 'opzionale'
            }
                break
            case 'noBiglietto': {
                setFormData2({ ...formData2, biglietto: false, noBiglietto: true, sito: false })
                sitoFacol_Obbl.current = 'opzionale'
            }
                break
            case 'sito': {
                setFormData2({ ...formData2, biglietto: false, noBiglietto: false, sito: true })
                sitoFacol_Obbl.current = 'obbligatorio'
            }
                break
            default: console.log(name)
        }
        prezzoId.current.style.border !== '1px solid black' && (prezzoId.current.style.border = '1px solid black')
        descrizione.current.style.border !== '1px solid black' && (descrizione.current.style.border = '1px solid black')
    }
    function handleOpzioniEvento(e) {
        const { name, value, type, checked } = e.target//attributi degli input
        const inputValue = type === "checkbox" ? checked : value//se type=checkbox valorizza checked altrimenti valorizza value
        let rt = []
        if (inputValue === true) {
            if (formData2.opzioniEvento !== '') rt = formData2.opzioniEvento.split(',')
            rt.push(name)
        } else
            if (inputValue === false) {
                rt = formData2.opzioniEvento.split(',').filter(item => item !== name)
            }
        setFormData2({ ...formData2, [name]: inputValue, opzioniEvento: rt.toString() })
    }
    function handleDescrizione(e) {
        setFormData2({ ...formData2, descrizione: e })
        setTextEmpty({ descrizione: formData2.descrizione.length })
    }
    const videoRemove = async (e) => {
        const v = document.getElementById('progress')
        v.style.width = '0'; v.style.transition = 'width 0.1s'; document.getElementById('container').style.border = '1px solid transparent'
        document.getElementById('upload-video').value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                setFormData2({ ...formData2, video: null })
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('lblVideo').style.display = 'block'//visualizzo '+video'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-video/${formData2.video}`)
        } catch (err) { setMsgVideo({ ...msgVideo, videoStateMessage: '*** Problemi con la connessione ***' }); console.error(err); return }
        removeFadeOut(document.getElementById('videoPreview'), 200)
        removeFadeOut(document.getElementById('iconaDelVideo'), 200)
        setMsgVideo({ videoStateMessage: null })
    }
    async function handleSubmit(e) {
        e.preventDefault()//al onSubmit la pagina non si aggiorna perchè abbiamo prevenuto il default
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!validRegex.test(formData2.email) || formData2.email === '') {
            setTextEmpty({ emailValidate: 'Email non valida' }); return
        }
        if (formData2.descrizione.length >= 5499 || formData2.descrizione.length === 0) {
            setTextEmpty({ descrizione: 'max 5500' }); window.scrollTo(0, 150)
            descrizione.current.style.border = '1px solid red'; return
        } else
            if (formData2.sito === true && formData2.url === "") {
                setTextEmpty({ sitoWeb: 'Campo obbligatorio' }); window.scrollTo(0, 1600); return
            } else
                if (formData2.telefono) {
                    if (/^[0-9\s-]+$/.test(formData2.telefono) === false) {
                        setTextEmpty({ telefono: '*** Carattere o simbolo non conforme ***' }); window.scrollTo(0, 1700); return
                    }
                }
        if (formData2.biglietto === true) {
            if (formData2.prezzo === '') {
                setValidate('Campo obbligatorio')
                prezzoId.current.style.border = '1px solid red'; return
            } else
                if (formData2.prezzo <= 0) {
                    setValidate('Valore errato')
                    prezzoId.current.style.border = '1px solid red'; return
                }
        } else formData2.prezzo = 0

        // ---------------- SE TUTTO E' IN CHECK --------------------
        const object = { ...formData2, foto: foto }
        dispatch(aggiorna(object))
        navigate('/confirmEditEvento')
    }
    function vaiAlSitoUff() {
        bannerSitoUff.current.style.display = 'block'
        btnInfoSitoUff.current.style.display = 'none'
        let time = setTimeout(editBanner, 8000)
        document.addEventListener('mouseup', () => {
            bannerSitoUff.current.style.display = 'none'
            btnInfoSitoUff.current.style.display = 'block'
            clearTimeout(time)
        })
        function editBanner() {
            bannerSitoUff.current.style.display = 'none'
            btnInfoSitoUff.current.style.display = 'block'
        }
    }
    function controlNavbar() {// evito il refresh della pagina se con il telefono scrollo troppo verso l'alto
        if (window.scrollY < 30) { window.scrollTo(0, 31) }
    }

    useEffect(() => {
        if (formData2.video) {
            document.getElementById('lblVideo').style.display = 'none' // se c'è un video tolgo '+Video' nel primo render della pagina
        }
    }, [formData2.video])

    useEffect(() => {//gestione del DOM prezzo del biglietto e sue opzioni
        if (formData2.biglietto === true) {
            prezzoDom.current.style.display = 'block'
            setFormData2({ ...formData2, noBiglietto: false })
        } else {
            prezzoDom.current.style.display = 'none'
            prezzoId.current.value = ''
            setFormData2({ ...formData2, prezzo: '', opzioniBiglietto: '' })
            if (formData2.sito === true) sitoFacol_Obbl.current = 'Obbligatorio'
        }
    }, [formData2.biglietto])

    useEffect(() => {
        if (!formData2.idEvento || !localStorage.getItem('idUser')) navigate('/')
        if (formData2.ospiti) {
            document.getElementById('divAggiungiOspiti').style.display = 'block'
            document.getElementById('spanOspiti').innerHTML = '-'
        }
        window.addEventListener('scroll', controlNavbar)
        return () => { window.removeEventListener('scroll', controlNavbar) }
    }, [])

    // useEffect(() => { console.log('formData2:', formData2.ospiti) }, [formData2])

    return (<>
        {localStorage.getItem('email') === 'maladmin@admin.it' ? <div><NavbarTopAdmin /> <NavbarBottomAdmin /></div>
            : <NavbarNotAuth />
        }
        <div className='container' style={{ marginBottom: '0rem', marginTop: '6rem' }}>
            <h2 style={{ marginTop: '5em' }}>Modifica evento (2)</h2>
            <h4 style={{ marginTop: '3rem' }}>DESCRIVI L'EVENTO *<span style={{ color: 'maroon', fontSize: 'small' }}> (max 5500)</span></h4>
            <div ref={descrizione}>
                <ReactQuill
                    value={formData2.descrizione}
                    theme="snow"
                    onChange={handleDescrizione}
                    placeholder="Es: dal 1 al 4 novembre si svolgerà a Spoleto il grande Show dell' open jazz band..."
                    modules={{
                        toolbar: [
                            ['bold', 'italic', 'underline'], // Solo le funzioni base che ti servono
                            ['link'],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            ['clean'] // Rimuove la formattazione se l'utente incolla testo sporco
                        ]
                    }}
                />
            </div>
            {textEmpty.descrizione && <p style={{ color: 'red' }}><i>{textEmpty.descrizione} - max 5500</i></p>}

            {/* ------------------- Aggiungi OSPITI ------------------------------ */}
            <div>
                <h5 style={{ marginTop: '3rem' }}>AGGIUNGI OSPITI
                    <span style={{ border: '1px solid grey', marginLeft: '5px', padding: '0 10px', cursor: 'pointer', fontSize: 'medium' }} id="spanOspiti" onClick={() => {
                        const xcv = document.getElementById('divAggiungiOspiti')
                        const bnm = document.getElementById('spanOspiti')
                        if (bnm.textContent === '+') { bnm.innerHTML = '-'; xcv.style.display = 'block' }
                        else { bnm.innerHTML = '+'; xcv.style.display = 'none' }
                    }}>+</span>
                </h5>
                <div id="divAggiungiOspiti" style={{ display: 'none', width: '70%' }}>
                    <i style={{ fontSize: 'small', color: 'maroon' }}>Usa % per separare l'ospite da eventuali dettagli (es. Bach Orchestra%Trio di musica classica)</i>
                    {numOspiti.map((ospite) => {
                        const nm = "ospite" + ospite
                        return (
                            <input key={ospite} className="form-control mt-3"
                                name={`ospite${ospite}`}
                                maxLength={300}
                                onChange={handleInputChange}
                                placeholder={`ospite ${ospite}`}
                                type="text"
                                defaultValue={formData2[nm]}// chiave dinamica
                            />
                        )
                    })
                    }
                </div><hr />
            </div>

            <form onSubmit={handleSubmit}>

                {/* ------------------------------- aggiungi innagini --------------------------- */}
                <EditImg folder={''} numero={[0, 1, 2]} invioFoto={(e) => { setFoto(e) }} />
                <br /><hr />

                {/* ---------------------------------- aggiungi video --------------------------- */}
                <div>
                    <h4 style={{ marginTop: '0' }}>AGGIUNGI VIDEO (max 5 min)</h4>
                    <p style={{ opacity: '.7' }}><i>*** opzionale ***</i></p>
                    <div style={{ border: '2px solid cornflowerblue', width: '200px', height: '130px', textAlign: 'center', margin: '2em 0 0 3em', borderRadius: '5px' }}>
                        <label htmlFor="upload-video" style={{ cursor: 'pointer' }} id='lblVideo'>
                            + Video
                            <span id="rotaryVideo" style={{ display: 'none' }}>
                                <RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' />
                            </span>
                        </label>
                        {formData2.video &&
                            <div>
                                <div style={{ marginTop: '-28px' }}>
                                    <button style={{ marginLeft: '10em', border: 'transparent', backgroundColor: 'transparent' }}
                                        onClick={videoRemove} id={'iconaDelVideo'} type='button'>
                                        ❌
                                    </button>
                                </div>
                                <div>
                                    {/* ------------- preview del video proveniente da MYSQL ------------ */}
                                    <video src={`https://leuro-bucket.s3.amazonaws.com/video/${formData2.video}`} id={'videoPreview'}
                                        style={{ width: '198px', height: '128px', borderRadius: '5px' }} controls />
                                </div>
                            </div>
                        }
                        <input id='upload-video' style={{ opacity: '0', fontSize: '0px' }}
                            type='file'
                            name='video'
                            accept="video/*"
                            onChange={videoChange} />
                    </div>
                    {/* ------------ barra di avanzamento ----------------------- */}
                    <div style={{ width: '35%', backgroundColor: 'transparent', margin: '1em 0 0 1em' }} id='container'>
                        <div style={{ width: '0', height: '10px', backgroundColor: 'darkturquoise' }} id='progress'>
                        </div>
                    </div>
                    {msgVideo.videoStateMessage &&
                        <p style={{ color: 'navy', margin: '0 0 0 1em' }}><i>{msgVideo.videoStateMessage}</i></p>
                    }
                </div>
                {/* --------------------------- Incorpora Video ------------------ */}
                <div>
                    <p className='fs-4'>INCORPORA UN VIDEO DA YOUTUBE
                        <span style={{ fontSize: 'x-small', backgroundColor: 'maroon', color: 'white', borderRadius: '5px', marginLeft: '1em', padding: '5px', cursor: 'pointer' }}
                            onClick={() => {
                                document.getElementById('esempioIncorp').style.display = 'block'; setTimeout(() => {
                                    document.getElementById('esempioIncorp').style.display = 'none'
                                }, 15000)
                            }}
                        >esempio
                        </span>
                    </p>
                    <input className="form-control"
                        defaultValue={formData2.incorporaUrl}
                        name='incorporaUrl'
                        onChange={handleInputChange}
                        placeholder='URL del video'
                        type='text' />
                    <div id='esempioIncorp' style={{
                        border: '1px solid grey', width: '40%', height: '220px', position: 'absolute', backgroundColor: 'whitesmoke', left: '14em',
                        fontSize: 'small', padding: '10px', display: 'none'
                    }}>
                        <img src={require('../userNotAuth/image/icons8-chiudi-macos-32.png')} style={{ cursor: 'pointer' }} alt=''
                            onClick={() => { document.getElementById('esempioIncorp').style.display = 'none' }} />
                        Sopra al video di YouTube clicca con il tasto destro del mouse e seleziona <i>Copia URL Video</i>. Poi incolla l'URL appena copiato nel campo <i>URL del video</i> qui sopra.
                    </div>
                </div>

                <h5 style={{ marginTop: '1rem' }}>OPZIONI EVENTO</h5>
                <div className='mt-3' style={{ display: 'grid', gridTemplateColumns: '2rem 14rem', gap: '4px' }} >
                    <div><input type='checkbox'
                        name='parcheggio'
                        checked={formData2.parcheggio}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Parcheggio gratuito</label></div>

                    <div><input type='checkbox'
                        name='navetta'
                        checked={formData2.navetta}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Servizio navetta</label></div>

                    <div><input type='checkbox'
                        name='mercatini'
                        checked={formData2.mercatini}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Mercatini</label></div>

                    <div><input type='checkbox'
                        name='fiera'
                        checked={formData2.fiera}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Fiera espositiva</label></div>

                    <div><input type='checkbox'
                        name='standGastronomici'
                        checked={formData2.standGastronomici}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Stand gastronomici</label></div>

                    <div><input type='checkbox'
                        name='streetFood'
                        checked={formData2.streetFood}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Street Food</label></div>

                    <div><input type='checkbox'
                        name='areaTavoli'
                        checked={formData2.areaTavoli}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Area tavoli</label></div>

                    <div><input type='checkbox'
                        name='birraArtigianale'
                        checked={formData2.birraArtigianale}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Birra artigianale</label></div>

                    <div><input type='checkbox'
                        name='musica'
                        checked={formData2.musica}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Musica dal vivo</label></div>

                    <div><input type='checkbox'
                        name='djSet'
                        checked={formData2.djSet}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Dj-set</label></div>

                    <div><input type='checkbox'
                        name='centroStorico'
                        checked={formData2.centroStorico}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Centro storico visitabile</label></div>

                    <div><input type='checkbox'
                        name='addobbi'
                        checked={formData2.addobbi}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Addobbi scenografici</label></div>

                    <div><input type='checkbox'
                        name='artisti'
                        checked={formData2.artisti}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Artisti di strada</label></div>

                    <div><input type='checkbox'
                        name='truccabimbi'
                        checked={formData2.truccabimbi}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Truccabimbi</label></div>


                    <div><input type='checkbox'
                        name='attrazioniBambini'
                        checked={formData2.attrazioniBambini}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Attrazioni per bambini</label></div>

                    <div><input type='checkbox'
                        name='liscio'
                        checked={formData2.liscio}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Ballo liscio</label></div>

                    <div><input type='checkbox'
                        name='gruppo'
                        checked={formData2.gruppo}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Balli di gruppo</label></div>

                    <div><input type='checkbox'
                        name='scuolaDiBallo'
                        checked={formData2.scuolaDiBallo}
                        onChange={handleOpzioniEvento} />
                    </div>
                    <div><label>Scuola di ballo</label></div>
                </div><hr />

                {/* -------------------------------------- link ---------------------------- */}
                <div className="col-md-6 mt-2">
                    <label>SITO WEB/URL
                        <img className='ms-1' src={require('../userNotAuth/image/icons8-sito-web-30.png')} alt='' width={20} /><i> ({sitoFacol_Obbl.current})</i>
                    </label>
                    <input className="form-control" id="url"
                        type='text'
                        name='url'
                        defaultValue={formData2.url}
                        onChange={handleInputChange} />
                    {textEmpty.sitoWeb && <p style={{ color: 'red' }}><i>{textEmpty.sitoWeb}</i></p>}
                    <label>URL FB
                        <img className='ms-1' src={require('../userNotAuth/image/icons8-fb-48.png')} alt='' width={20} />
                    </label>
                    <input className="form-control" id="fb"
                        type='text'
                        name='fb'
                        defaultValue={formData2.fb}
                        onChange={handleInputChange} />
                    <label>URL INSTAGRAM
                        <img className='ms-1' src={require('../userNotAuth/image/icons8-instagram-48.png')} alt='' width={20} />
                    </label>
                    <input className="form-control" id="youTube"
                        type='text'
                        name='youTube'
                        defaultValue={formData2.youTube}
                        onChange={handleInputChange} />

                    <h4 style={{ marginTop: '2rem' }}>INFO ORGANIZZATORE </h4>
                    <div className='mt-2'> <label htmlFor='form-control fw-bold'>Telefono</label></div>
                    <input className="form-control" id="telefono"
                        defaultValue={formData2.telefono}
                        name='telefono'
                        maxLength={20}
                        onChange={handleInputChange}
                        placeholder='opzionale'
                        type='text' />
                    {textEmpty.telefono && <p style={{ color: 'red' }}>{textEmpty.telefono}</p>}

                    {/* -------------------------- Email -------------------- */}
                    <label htmlFor='form-control fw-bold'>Email *</label>
                    <input className="form-control" id="email"
                        defaultValue={formData2.email}
                        name='email'
                        required
                        onChange={handleInputChange}
                        type='text' />
                    {textEmpty.emailValidate && <p style={{ color: 'red' }}>{textEmpty.emailValidate}</p>}

                    <p className='mt-3'>Descrizione organizzatore <span style={{ color: 'maroon', fontSize: 'small' }}> (max 1000)</span></p>
                    <textarea style={{ padding: '5px', marginTop: '10px' }} className='form-control' id="infoOrganizzatore"
                        name="infoOrganizzatore"
                        rows='10'
                        maxLength={1000}
                        onChange={handleInputChange}
                        placeholder="Es: l'associazione nasce 1 anno fa per opera di..."
                        defaultValue={formData2.infoOrganizzatore}
                    >
                    </textarea>
                    {textEmpty.infoOrganizzatore && <p style={{ color: 'red' }}>{textEmpty.infoOrganizzatore}</p>}
                </div>


                <h5 className='mt-5'>OPZIONI BIGLIETTO</h5>
                <div style={{
                    display: 'grid', gridTemplateColumns: '10rem 1rem', gap: '0px', marginTop: '0rem',
                    border: '1px solid gainsboro', padding: '15px 5px', position: 'relative'
                }}>

                    <div><label htmlFor='sito'>Vai al sito ufficiale</label></div>
                    <div><input type='checkbox' id="sito"
                        name='sito'
                        checked={formData2.sito}
                        onChange={handleInputChange}
                    /></div>
                    <div style={{
                        position: 'absolute', left: '11.5rem', top: '15px', fontSize: 'small', cursor: 'pointer',

                    }} ref={btnInfoSitoUff} onClick={vaiAlSitoUff}>
                        → <i style={{ border: '1px solid grey', padding: '0 2px' }}>info</i>
                    </div>

                    <div style={{
                        position: 'absolute', left: '12rem', fontSize: 'small', display: 'none',
                        fontWeight: '600', padding: '7px 1px'
                    }}
                        ref={bannerSitoUff}>
                        <i>L'utente interessato all'acquisto del biglietto sarà indirizzato al sito ufficiale dell'evento</i>
                    </div>

                    <div><label htmlFor="biglietto"> Senza biglietto </label></div>
                    <div><input type="checkbox" id="noBiglietto"
                        name='noBiglietto'
                        checked={formData2.noBiglietto}
                        onChange={handleInputChange} />
                    </div>

                    <div><label htmlFor="biglietto"> Biglietto d'ingresso </label></div>
                    <div><input type="checkbox" id='biglietto'
                        name='biglietto'
                        checked={formData2.biglietto}
                        onChange={handleInputChange} />
                    </div>
                </div>

                <div ref={prezzoDom} style={{ display: 'none', marginTop: '2rem', paddingLeft: '1rem' }}>
                    <label htmlFor='prezzo'>Prezzo biglietto €</label>
                    <input style={{ width: '5rem', height: '2rem', marginLeft: '3rem' }}
                        type='number' ref={prezzoId} id="prezzo"
                        name='prezzo'
                        defaultValue={formData2.prezzo}
                        onChange={handleInputChange} />
                    {validate && <p style={{ color: 'red' }}><i>{validate}</i></p>}

                    <p className='mt-3'>Opzioni biglietto:</p>
                    <textarea style={{ padding: '5px', marginTop: '10px' }} className='form-control' id="opzioniBiglietto"
                        name="opzioniBiglietto"
                        rows='5'
                        maxLength={100}
                        onChange={handleInputChange}
                        placeholder='Es: i bambini fino a 3 anni non pagano...'
                        defaultValue={formData2.opzioniBiglietto}
                    >
                    </textarea>
                    {textEmpty.opzioniBiglietto && <p style={{ color: 'red' }}>{textEmpty.opzioniBiglietto}</p>}
                </div>

                <p className='mt-2 fs-6'><i>* campi obbligatori</i></p>
                <div className='mt-3'>
                    <button type='button' className='btn btn-secondary' onClick={() => {
                        navigate('/editEvento1', { replace: true, state: { idEvento: formData2.idEvento } })
                    }} >
                        Indietro
                    </button>
                    <button type='submit' className='btn btn-primary' style={{ marginLeft: '3rem' }}>Avanti</button>
                </div>
            </form >

        </div >
        <DivBottom />
    </>)
}
export default EditEvento2